export const fetchProfile = () => ({
  method: "GET",
  endpoint: `/profile`,
});

export const fetchDashboardStats = () => ({
  method: "GET",
  endpoint: `/dashboard/stats`,
});

export const fetchSubcriptions = () => ({
  method: "GET",
  endpoint: `/profile/subscriptions`,
});

export const updateProfile = (values) => ({
  method: "PUT",
  endpoint: `/profile`,
  headers: {
    "Content-Type": "application/json",
  },
  body: values,
});

export const changePlan = (values) => ({
  method: "POST",
  endpoint: `/profile/change-plan`,
  headers: {
    "Content-Type": "application/json",
  },
  body: values,
});

export const updateStorageToken = (values) => ({
  method: "PUT",
  endpoint: `/integrations/${values.type}`,
  headers: {
    "Content-Type": "application/json",
  },
  body: values,
});

export const cancelSubscription = (values) => ({
  method: "delete",
  endpoint: `/profile/subscriptions/${values.id}/cancel`,
  headers: {
    "Content-Type": "application/json",
  },
  body: values,
});

export const requestDemo = (values) => ({
  method: "POST",
  endpoint: `/contact`,
  headers: {
    "Content-Type": "application/json",
  },
  skipAuth: false,
  prefix: " ",
  body: values,
});
export const requestPayment = (values) => ({
  method: "POST",
  endpoint: `/balance/redeem`,
  headers: {
    "Content-Type": "application/json",
  },
  body: values,
});
